import { partition } from 'lodash'
import { isDone, type Upload, type UploadGroupId, getFileIds } from '../../../app-core/lib/upload/Upload'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { IDB_uploads } from '../IDB/IDB.deviceDB'
import { deleteChunks } from './fileChunk'

/**
 * Removes uploads and associated file contents
 */
export async function Uplo_deleteUploads(logger: ClientLogger, uploads: Upload[]) {
    const fileIds = getFileIds(uploads)

    await IDB_uploads().bulkDelete(fileIds)
    logger.log('deleted uploads', { fileIds })

    await deleteChunks(uploads)
    logger.log('deleted file chunks', { fileIds })
}

/**
 * For all uploads in group, if done then delete otherwise mark them for later deletion
 */
export async function Uplo_releaseGroups(logger: ClientLogger, groupIds: UploadGroupId[]) {
    try {
        logger.log('releasing uploads for groups', { groupIds })

        // Read all the uploads for groups
        const uploads = await IDB_uploads().where('groupId').anyOf(groupIds).toArray()

        // Split into those that are done and not
        const [done, stillUploading] = partition(uploads, isDone)

        if (stillUploading.length > 0) {
            const fileIds = getFileIds(stillUploading)

            // Mark the in progress ones as deletable once they're done uploading
            const count = await IDB_uploads().where(':id').anyOf(fileIds).modify({ canBeDeletedWhenDone: true })
            logger.log('marked uploads as deletable', { fileIds: getFileIds(stillUploading), count })
        }

        if (done.length > 0) {
            // And delete all the ones that are done
            await Uplo_deleteUploads(logger, done)
        }
    } catch (error) {
        logger.error(error)
    }
}
